import { Routes } from '@angular/router';
import { PageLogInComponent } from './pagesAdmin/page-log-in/page-log-in.component';
import { MenuLayoutComponent } from './layout-components/menu-layout/menu-layout.component';
import { AdminLayoutComponent } from './layout-components/admin-layout/admin-layout.component';
import { PageMenuListComponent } from './pagesAdmin/page-menu-list/page-menu-list.component';
import { PageAdminCategoriesComponent } from './pagesAdmin/page-admin-categories/page-admin-categories.component';
import { PageAddItemComponent } from './pagesAdmin/page-add-item/page-add-item.component';
import { PageAddCategoryComponent } from './pagesAdmin/page-add-category/page-add-category.component';
import { PageItemsOrderAdminComponent } from './pagesAdmin/page-items-order-admin/page-items-order-admin.component';
import { PageCategoriesOrderComponent } from './pagesAdmin/page-categories-order/page-categories-order.component';
import { PageExportMenuComponent } from './pagesAdmin/page-export-menu/page-export-menu.component';
import { authGuard } from './core/guards/auth.guard';
import { PageIntroComponent } from './pagesUser/page-intro/page-intro.component';
import { PageLanguagesComponent } from './pagesUser/page-languages/page-languages.component';
import { PageMenuItemsUserComponent } from './pagesUser/page-menu-items-user/page-menu-items-user.component';
import { PageSingleMenuItemUserComponent } from './pagesUser/page-single-menu-item-user/page-single-menu-item-user.component';
import { PageAddCouponComponent } from './pagesAdmin/page-add-coupon/page-add-coupon.component';
import { PageCategoriesComponent } from './pagesUser/page-categories/page-categories.component';
import { SingleItemCardComponent } from './userComponents/single-item-card/single-item-card.component';
import { OrderPageComponent } from './pagesUser/order-page/order-page.component';

export const routes: Routes = [
  {
    path: '',
    component: MenuLayoutComponent,
    children: [
      { path: '', component: PageIntroComponent },
      { path: 'language', component: PageLanguagesComponent },
      
      { path: 'menuItems', component: PageMenuItemsUserComponent },
      { path: 'menuItems/:id', component: PageMenuItemsUserComponent },

      { path: 'singleItem', component: PageSingleMenuItemUserComponent },
      { path: 'singleItem/:id', component: PageSingleMenuItemUserComponent },

      { path: 'categories', component: PageCategoriesComponent },

      { path: 'orders', component: OrderPageComponent },

      

    ],
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: '', component: PageLogInComponent},
      { path: 'logIn', component: PageLogInComponent, canActivate: [authGuard] },
      { path: 'menuList', component: PageMenuListComponent, canActivate: [authGuard] },
      { path: 'categories', component: PageAdminCategoriesComponent, canActivate: [authGuard] },
      { path: 'addItem', component: PageAddItemComponent, canActivate: [authGuard] },
      { path: 'addCategory', component: PageAddCategoryComponent, canActivate: [authGuard] },
      { path: 'orderItems', component: PageItemsOrderAdminComponent, canActivate: [authGuard] },
      { path: 'orderCategories', component: PageCategoriesOrderComponent, canActivate: [authGuard] },
      { path: 'exportMenu', component: PageExportMenuComponent, canActivate: [authGuard] },
      { path: 'orderItems/:id', component: PageItemsOrderAdminComponent, canActivate: [authGuard] },
      { path: 'addCoupon', component: PageAddCouponComponent, canActivate: [authGuard] },

    ],
  },
];
